import React, { useRef, useState, useCallback, useEffect } from "react";
import { motion } from "framer-motion";
import "./styles.css";
import debounce from "lodash.debounce";
import {
  bgVariants,
  imgWrapVariants,
  largeItemVariants,
  logoVariants,
  standardItemVariants,
} from "./variants";
import { contactData } from "../../globals/data";
import Showreel from "../../components/Showreel/Showreel";

const ContactMob = () => {
  const [imageCounter, setImageCounter] = useState(1);
  const [isColour, setIsColour] = useState(true);
  const [isShowreelVisible, setIsShowreelVisible] = useState(false);
  const btsImageCountRefs = useRef([]);
  const imgWrapperRef = useRef(null);
  const [showreelVisbile, setShowreelVisible] = useState(false);
  const btsLength = contactData.numberStills;

  const handleShowreelClick = () => {
    setShowreelVisible(true);
  };

  const debounceAutomaticIncrement = useCallback(
    debounce((useVal, dir) => {
      try {
        let isIncrement = dir;
        try {
          btsImageCountRefs.current[useVal - 1].classList.add("bts-anim");
          if (isIncrement > 0) {
            btsImageCountRefs.current[useVal - 1].classList.add(
              "next-exit-counter",
            );
            btsImageCountRefs.current[useVal - 1].classList.remove(
              "active-counter",
            );
          } else {
            btsImageCountRefs.current[useVal - 1].classList.add(
              "prev-exit-counter",
            );
            btsImageCountRefs.current[useVal - 1].classList.remove(
              "active-counter",
            );
          }
        } catch {}

        let newVal = useVal + isIncrement;
        if (newVal <= 0) {
          // to end
          newVal = btsLength;
          for (let i = 0; i < btsLength - 1; i++) {
            if (i !== useVal - 1) {
              btsImageCountRefs.current[i].classList.remove(
                "prev-exit-counter",
              );
              btsImageCountRefs.current[i].classList.remove("bts-anim");
              btsImageCountRefs.current[i].classList.add("next-exit-counter");
            }
          }
        } else if (newVal > btsLength) {
          //back to start
          newVal = 1;
          for (let i = 0; i < btsLength - 1; i++) {
            if (i !== useVal - 1) {
              btsImageCountRefs.current[i].classList.remove(
                "next-exit-counter",
              );
              btsImageCountRefs.current[i].classList.remove("bts-anim");
              btsImageCountRefs.current[i].classList.add("prev-exit-counter");
            }
          }
        }

        btsImageCountRefs.current[newVal - 1].classList.add("bts-anim");
        btsImageCountRefs.current[newVal - 1].classList.remove(
          "next-exit-counter",
        );
        btsImageCountRefs.current[newVal - 1].classList.remove(
          "prev-exit-counter",
        );
        btsImageCountRefs.current[newVal - 1].classList.add("active-counter");
        setImageCounter(newVal);

        // create image
        try {
          let newEle = document.createElement("div");
          let bgEle = document.createElement("div");
          bgEle.classList.add("bts-img");
          newEle.classList.add("bts-img-wrap");
          newEle.appendChild(bgEle);
          bgEle.style.backgroundImage =
            'url("../media/BTS/placeholder/BTS_' + (newVal - 1) + '.webp")';

          imgWrapperRef.current.appendChild(newEle);
        } catch {}
        debounceAutomaticIncrement(newVal, isIncrement);
      } catch {
        console.warn("error in mobile debouncer");
      }
    }, 5000),
    [],
  );

  useEffect(() => {
    debounceAutomaticIncrement(1, 1);
  }, []);

  const handleImageChange = (isIncrement) => {
    let currentImages = document.getElementsByClassName("bts-img-wrap");
    if (currentImages.length > 20) {
      for (let i = 10; i > 0; i--) {
        console.log(currentImages[i]);
        currentImages[i].remove();
      }
    }

    //exit image counter
    try {
      btsImageCountRefs.current[imageCounter - 1].classList.add("bts-anim");
      if (isIncrement > 0) {
        btsImageCountRefs.current[imageCounter - 1].classList.add(
          "next-exit-counter",
        );
        btsImageCountRefs.current[imageCounter - 1].classList.remove(
          "active-counter",
        );
      } else {
        btsImageCountRefs.current[imageCounter - 1].classList.add(
          "prev-exit-counter",
        );
        btsImageCountRefs.current[imageCounter - 1].classList.remove(
          "active-counter",
        );
      }
    } catch {}

    let newVal = imageCounter + isIncrement;
    if (newVal <= 0) {
      // to end
      newVal = btsLength;
      for (let i = 0; i < btsLength - 1; i++) {
        if (i !== imageCounter - 1) {
          btsImageCountRefs.current[i].classList.remove("prev-exit-counter");
          btsImageCountRefs.current[i].classList.remove("bts-anim");
          btsImageCountRefs.current[i].classList.add("next-exit-counter");
        }
      }
    } else if (newVal > btsLength) {
      //back to start
      newVal = 1;
      for (let i = 0; i < btsLength - 1; i++) {
        if (i !== imageCounter - 1) {
          btsImageCountRefs.current[i].classList.remove("next-exit-counter");
          btsImageCountRefs.current[i].classList.remove("bts-anim");
          btsImageCountRefs.current[i].classList.add("prev-exit-counter");
        }
      }
    }

    btsImageCountRefs.current[newVal - 1].classList.add("bts-anim");
    btsImageCountRefs.current[newVal - 1].classList.remove("next-exit-counter");
    btsImageCountRefs.current[newVal - 1].classList.remove("prev-exit-counter");
    btsImageCountRefs.current[newVal - 1].classList.add("active-counter");
    setImageCounter(newVal);

    // create image
    try {
      let newEle = document.createElement("div");
      let bgEle = document.createElement("div");
      bgEle.classList.add("bts-img");
      newEle.classList.add("bts-img-wrap");
      newEle.appendChild(bgEle);
      bgEle.style.backgroundImage =
        'url("../media/BTS/placeholder/BTS_' + (newVal - 1) + '.webp")';

      imgWrapperRef.current.appendChild(newEle);
    } catch {}

    debounceAutomaticIncrement.cancel();
    debounceAutomaticIncrement(newVal, isIncrement);
  };

  const handleImageCounter = (isIncrement) => {
    handleImageChange(isIncrement);
  };

  return (
    <>
      {contactData && (
        <motion.div
          className="contact-mob__wrapper"
          initial="initial"
          animate="animate"
          exit="exit"
          variants={bgVariants}
        >
          <div className="m-contact-content">
            <div className="m-upper-section">
              <motion.div className="m-logo__wrapper" variants={logoVariants}>
                <img
                  className="m-logo"
                  src={"../media/branding/centerskewblack.png"}
                />
              </motion.div>
              <div className="m-contact-credits__wrapper">
                <div className="credits-top-section">
                  <div className="m-right">
                    <div className="m-span_wrapper">
                      <motion.span variants={standardItemVariants} custom={2}>
                        TOTTENHAM
                      </motion.span>
                    </div>
                    <div className="m-span_wrapper">
                      <motion.span variants={standardItemVariants} custom={3}>
                        LONDON, UNITED KINGDOM
                      </motion.span>
                    </div>
                    <div className="m-span_wrapper">
                      <motion.span variants={standardItemVariants} custom={4}>
                        51.5072° N, 0.1276° W
                      </motion.span>
                    </div>
                  </div>
                </div>
                <div className="credits-bottom-section">
                  <div className="mob-crdt-bottom-left">
                    <div className="mob-socs">
                      <div className="m-span_wrapper">
                        <a
                          href="https://youtube.com/@donprod?si=cMl8Qz6R41nwdX4X"
                          target="_blank"
                        >
                          <motion.span
                            variants={standardItemVariants}
                            custom={4}
                          >
                            YOUTUBE
                          </motion.span>
                        </a>
                      </div>
                    </div>

                    <div className="mob-socs">
                      <div className="m-span_wrapper">
                        <a
                          href="https://www.instagram.com/donprod"
                          target="_blank"
                        >
                          <motion.span
                            variants={standardItemVariants}
                            custom={5.5}
                          >
                            INSTAGRAM
                          </motion.span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="mob-crdt-bottom-right">
                    <div className="mob-socs">
                      <div className="m-span_wrapper">
                        <a
                          href="https://www.instagram.com/tom_kral/"
                          target="_blank"
                        >
                          <motion.span
                            variants={standardItemVariants}
                            custom={5}
                          >
                            TIKTOK
                          </motion.span>
                        </a>
                      </div>
                    </div>

                    <div className="mob-socs">
                      <div className="m-span_wrapper">
                        <a
                          href="mailto:doubleornothingproductions@gmail.com"
                          target="_blank"
                        >
                          <motion.span
                            variants={standardItemVariants}
                            custom={7}
                          >
                            EMAIL US
                          </motion.span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m-lower-section">
              <div className="contact-img-section">
                <div className="heading-sec__wrapper">
                  <div className="contact-img-heading">
                    {"READY WHEN YOU ARE."
                      .split("")
                      .flat()
                      .map((char, idx) =>
                        char == " " ? (
                          <span>&nbsp;</span>
                        ) : (
                          <motion.span
                            variants={largeItemVariants}
                            custom={6 + 0.125 * idx}
                          >
                            {char}
                          </motion.span>
                        ),
                      )}
                  </div>
                  <div
                    className="mob-showreel__wrapper"
                    onClick={() => handleShowreelClick()}
                  >
                    <motion.span variants={standardItemVariants} custom={10}>
                      VIEW SHOWREEL
                    </motion.span>
                  </div>
                </div>
                <motion.div className="img-hide" style={{ overflow: "hidden" }}>
                  <motion.div
                    className="mob-cont-img__wrapper"
                    ref={imgWrapperRef}
                    variants={imgWrapVariants}
                  >
                    <motion.div
                      className="bts-img-wrap"
                      style={{
                        backgroundImage:
                          'url("../media/BTS/placeholder/BTS_0.webp")',
                        animationDelay: "0.25s",
                      }}
                    />
                    <motion.div
                      className="bts-img-wrap-lrg"
                      style={{
                        backgroundImage:
                          'url("../media/BTS/placeholder/BTS_0.webp")',
                        animationDelay: "0.25s",
                      }}
                    />
                  </motion.div>
                </motion.div>
              </div>
              <div className="m-cont-footer">
                <div className="ego-section">
                  <div className="m-span_wrapper">
                    <motion.span variants={standardItemVariants} custom={9}>
                      DANNY.LINES
                    </motion.span>
                  </div>
                  <div className="m-span_wrapper">
                    <motion.span variants={standardItemVariants} custom={10.5}>
                      DESIGN & DEVELOPMENT
                    </motion.span>
                  </div>
                </div>
                <div className="mob-img-controls">
                  <div className="mob-pn-cont">
                    <div>
                      <motion.div
                        className="mob-img-counter"
                        variants={standardItemVariants}
                        custom={11}
                      >
                        <span style={{ opacity: 0 }}>999</span>
                        {Array(btsLength)
                          .fill(" ")
                          .map((item, idx) => (
                            <span
                              key={"bts-count-" + idx}
                              className={`con-bts-num ${idx == 0 ? "active-counter" : ""}`}
                              ref={(el) =>
                                (btsImageCountRefs.current[idx] = el)
                              }
                            >
                              {idx + 1 < 10
                                ? "00" + (idx + 1).toString()
                                : "0" + (idx + 1).toString()}
                            </span>
                          ))}
                        <span>/</span>
                        <span>0{contactData.numberStills}</span>
                      </motion.div>
                    </div>
                    <motion.div
                      className="mob-pn-wrap"
                      variants={standardItemVariants}
                      custom={13}
                    >
                      <span onClick={() => handleImageCounter(-1)}>PREV</span>
                      <span onClick={() => handleImageCounter(1)}>NEXT</span>
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="manual-cacher">
            {Array(contactData.numberStills)
              .fill(null)
              .map((item, idx) => (
                <img src={`../media/BTS/placeholder/BTS_${idx}.webp`} />
              ))}
          </div>
        </motion.div>
      )}
      <div className="showreel-video__wrapper">
        {contactData && (
          <Showreel
            videoLink={contactData.showreelLink}
            isVisible={showreelVisbile}
            setIsVisible={setShowreelVisible}
          />
        )}
      </div>
    </>
  );
};

export default ContactMob;
